export default __webpack_public_path__ + "static/media/main-banner.aff464cb.png";